import sortBy from 'lodash/sortBy'

export const ASSET_SALE = {
  id: 'assetSale',
  label: 'Asset Sale/Purchase'
}

export const SHARE_PURCHASE = {
  id: 'sharePurchase',
  label: 'Share purchase/sale'
}

export const CONFIDENTIALITY_AGREEMENT = {
  id: 'confidentialityAgreement',
  label: 'Confidentiality'
}

export const ESTATE_DOCUMENTATION = {
  id: 'estateDocumentation',
  label: 'Estate Documents'
}

export const EMPLOYEES = {
  id: 'employees',
  label: 'Employees & Consultants'
}

export const CONTRACTORS = {
  id: 'contractors',
  label: 'Contractors'
}

export const FINANCING = {
  id: 'financing',
  label: 'Financing'
}

export const TERM_SHEETS = {
  id: 'termSheets',
  label: "Term Sheets, MOU's & LOI's"
}

export const PROPERTY = {
  id: 'property',
  label: 'Property Agreements'
}

export const COMMERCIAL = {
  id: 'commercial',
  label: 'General Commercial'
}

const DOCUMENT_TYPE_LIST = sortBy(
  [
    ASSET_SALE,
    SHARE_PURCHASE,
    CONFIDENTIALITY_AGREEMENT,
    ESTATE_DOCUMENTATION,
    EMPLOYEES,
    CONTRACTORS,
    FINANCING,
    TERM_SHEETS,
    PROPERTY,
    COMMERCIAL
  ],
  'label'
)

const DOCUMENT_TYPE_LOOKUP = DOCUMENT_TYPE_LIST.reduce(
  (acc, documentType) => ({
    ...acc,
    [documentType.id]: documentType
  }),
  {}
)

export const getDocumentType = (documentTypeId) => {
  const documentType = DOCUMENT_TYPE_LOOKUP[documentTypeId]
  if (!documentType) {
    throw new Error(`Unknown document type "${documentTypeId}"`)
  }
  return documentType
}

const isDocumentType =
  ({ id }) =>
    (documentTypeId) =>
      id === documentTypeId

export const isAssetSale = isDocumentType(ASSET_SALE)
export const isSharePurchase = isDocumentType(SHARE_PURCHASE)
export const isConfidentialityAgreement = isDocumentType(
  CONFIDENTIALITY_AGREEMENT
)
export const isEstateDocumentation = isDocumentType(ESTATE_DOCUMENTATION)
export const isProperty = isDocumentType(PROPERTY)
export const isCommercial = isDocumentType(COMMERCIAL)

export const listAllDocumentTypes = () => DOCUMENT_TYPE_LIST
